module.exports = __webpack_public_path__ + "media/bootstrap-icons/discord-babdc353.svg";